import { getHttpClient } from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
import { getIsHubteamSubdomain } from 'flow-doctor-lib/constants/Env';
export const FETCH_USER_INFO = registerQuery({
  fieldName: 'userInfo',
  args: ['userId'],
  fetcher({
    userId
  }) {
    if (getIsHubteamSubdomain()) {
      return getHttpClient(true).get(`users/v2/users/${userId}`);
    }
    return getHttpClient(false).put('users/v2/app/hub-users/by-ids', {
      data: [userId]
    }).then(res => res.find(user => user.id === Number(userId))).catch(err => {
      console.error(err);
      throw err;
    });
  }
});